import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../assets/images/Icons/calendarIcon.svg";
import DownArrow from "../../../../../src/assets/images/Icons/icons/down_arrow.svg";
import UpArrow from "../../../../../src/assets/images/Icons/icons/up_arrow.svg";
import { FaCalendar } from "react-icons/fa";
import {
  makeAjax,
  respStatus,
  url,
  showMessage,
  gameList,
} from "../../../../helpers/global_helper";
import { formatPricewithdecimal } from "../../../NumberFormat";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setTotalNoResult } from "../../../../redux/actions";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";


const BonusEvent = (props) => {
  const device = useSelector((state) => state.CommonConfig.device_type);
  const dispatch = useDispatch();
  const [eventBonusData, setEventBonusData] = useState([]);

  const [startDate, setStartDate] = useState(new Date());
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [loading, setLoading] = useState(false);
  const [selectGameName, setSelectGameName] = useState("0");
  // const [gameName, setGameName] = useState([]);
  const [gameName, setGameName] = useState(gameList);
  const marketList = useSelector((state) => state.CommonConfig.marketList);
  const [turnoverPopup, setTurnoverPopup] = useState(false);
  const [turnoverDateId, setTurnoverDateId] = useState(null);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber);
  const perPage = useSelector((state) => state.paginationData.dataInOnePage);
  const dummyData = [
    {
      date: "2024-04-05",
      event: "1,755.0000",
      game: "1,755.0000",
      turnover: "2,000.00",
      categeory: "2,000.00",
      bonus_amount: "2,000.00",
    },
    {
      date: "2024-04-05",
      event: "1,755.0000",
      game: "1,755.0000",
      turnover: "2,000.00",
      categeory: "2,000.00",
      bonus_amount: "2,000.00",
    },
  ];

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  //================= OLD
  // const sortedData = () => {
  //   if (sortBy === "date") {
  //     return eventBonusData.slice().sort((a, b) => {
  //       const aValue = new Date(a[sortBy]).getTime();
  //       const bValue = new Date(b[sortBy]).getTime();
  //       return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
  //     });
  //   } else if (sortBy === "turnover" || sortBy === "bonusamount") {
  //     return eventBonusData.slice().sort((a, b) => {
  //       const aValue = parseFloat(a[sortBy]);
  //       const bValue = parseFloat(b[sortBy]);
  //       return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
  //     });
  //   } else if (sortBy) {
  //     return eventBonusData.slice().sort((a, b) => {
  //       const aValue = a[sortBy].toLowerCase();
  //       const bValue = b[sortBy].toLowerCase();
  //       return sortOrder === "asc"
  //         ? aValue.localeCompare(bValue)
  //         : bValue.localeCompare(aValue);
  //     });
  //   }
  //   return eventBonusData;
  // };
//=============


const sortedData = () => {
  let dataArray = [];

  if (Array.isArray(eventBonusData)) {
    dataArray = eventBonusData; // Already an array, no conversion needed
  } else if (eventBonusData && typeof eventBonusData === "object") {
    dataArray = Object.values(eventBonusData); // Convert object values to an array
  } else {
    return []; // Return an empty array if eventBonusData is null, undefined, or invalid
  }

  if (sortBy === "date") {
    return dataArray.slice().sort((a, b) => {
      const aValue = new Date(a.date).getTime();
      const bValue = new Date(b.date).getTime();
      return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
    });
  } else if (sortBy === "tover" || sortBy === "amount") {
    return dataArray.slice().sort((a, b) => {
      const aValue = parseFloat(a[sortBy]);
      const bValue = parseFloat(b[sortBy]);
      return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
    });
  } else if (sortBy === "name" || sortBy === "game_name") {
    return dataArray.slice().sort((a, b) => {
      const aValue = a.name.toLowerCase();
      const bValue = b.name.toLowerCase();
      return sortOrder === "asc"
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    });
  }
  return dataArray; // Default: no sorting applied
};

useEffect(() => {
}, [eventBonusData]);

  const CustomInput = ({ value, onClick }) => (
    <div style={{ position: "relative" }} className="custom_calendar">
      <input
        type="text"
        value={value}
        onClick={onClick} // This opens the calendar on input click
        readOnly // Prevent direct text input
      />
      <button
        onClick={onClick} // This also opens the calendar on icon click
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
        }}
      >
        {/* <img src={CalendarIcon} alt="" /> */}
        <FaCalendar />
      </button>
    </div>
  );
  // api for Game list
  // const featchGameList = () => {
  //   makeAjax(url.TOGEL_API.listGame).then((response) => {
  //     if (response.status != respStatus["SUCCESS"]) {
  //       if (response.code != "validation_error") {
  //         showMessage(response);
  //         return;
  //       }
  //       showMessage(response);
  //       return;
  //     }
  //     setGameName(response.data);
  //   });
  // };

  // useEffect(() => {
  //   featchGameList();
  // }, []);

  // api for Event Bonus list
  const fetchEventBonusList = () => {
    setLoading(true);

    let reqData = {
      // type: "bonus_event",
      page: pageNumber,
      length: perPage,
    };

    makeAjax(url.PLAYER_API.listEventBonus, reqData, url.PLAYER_MS_EXT).then(
      (response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code !== "validation_error") {
            showMessage(response);
            return;
          }
          showMessage(response);
          return;
        }
        setEventBonusData(response.data.data);
        // setEventBonusData(Array.isArray(response.data.data) ? response.data.data : []);

        dispatch(setTotalNoResult(response.data.total));
      }
    );
    setLoading(false);
  };

  useEffect(() => {
    fetchEventBonusList();
    const container = document.querySelector(".table_container");
    if (container) {
      container.scrollTop = 0;
    }
  }, [perPage, pageNumber]);

  // useEffect(() => {
  // }, [eventBonusData, sortBy, sortOrder]);
  

  const openTurnoverDatePopup = (turnoverDateId) => {
    setTurnoverDateId(turnoverDateId);
    setTurnoverPopup(true);
  };

  const closeTurnoverDatePopup = () => {
    setTurnoverPopup(false);
  };
  const handleGameSelectOptions = (e) => {
    const selectedValue = e.target.value;
    setSelectGameName(selectedValue);
  };


   // Helper function to map game_type to names
   const getGameTypeName = (gameType) => {
    switch (gameType) {
      case 3:
        return "CardGame";
      case 2:
        return "Dingdong";
      case 5:
        return "Togel";
      default:
        return "Unknown";
    }
  };

  return (
    <div className="trasaction_popup">
      {/* <div className="trasaction_top_bar">
        <div className="calendar">
          <DatePicker
            // showIcon
            customInput={<CustomInput />}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
          />
        </div>
        <div className="all_game_dropdown">
          <select className="dropdown" onChange={handleGameSelectOptions}>
            <option value="0">All</option>
            {marketList.length > 0 &&
              marketList.map(({ game_id, game_name }) => (
                <option key={game_id} value={game_id}>
                  {game_name}
                </option>
              ))}
          </select>
        </div>
        <div className="search">
          <button>{props.t("search")}</button>
        </div>
      </div> */}
      {/* table */}
      <div
        className={device === "Desktop" ? "informasi_tble_result" : "container"}
      >
        <table>
          <thead>
            <tr>
              <th onClick={() => handleSort("date")}>
                {props.t("date")}
                <span className="sorting_arrow">
                  {sortBy === "date" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("name")}>
                {props.t("event")}
                <span className="sorting_arrow">
                  {sortBy === "name" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("game_name")}>
                {props.t("game")}
                <span className="sorting_arrow">
                  {sortBy === "game_name" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("tover")}>
                {props.t("turnover")}
                <span className="sorting_arrow">
                  {sortBy === "tover" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th>{props.t("category")}</th>
              <th onClick={() => handleSort("amount")}>
                {props.t("bonus_amount")}
                <span className="sorting_arrow">
                  {sortBy === "amount" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
            </tr>
          </thead>

          <tbody>
            {!loading &&
              (sortedData().length === 0 ? (
                <tr className="table_data_empty_row ">
                  <td colSpan="6">{props.t("data_not_found")}</td>
                </tr>
              ) : (
                sortedData().map((item, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td>
                      <span
                        className="link_date"
                        onClick={() => openTurnoverDatePopup(item.created_date)}
                      >
                        {item.date}
                      </span>
                    </td>
                    <td>{item.name}</td>
                    <td>{item.game_name}</td>
                    <td>{formatPricewithdecimal(item.tover)}</td>
                    <td>{getGameTypeName(item.game_type)}</td>
                    <td>{formatPricewithdecimal(item.amount)}</td>
                  </tr>
                ))
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default withTranslation()(BonusEvent);
